"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTabContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const bridge_1 = require("@completeanatomy/bridge");
const react_router_dom_1 = require("react-router-dom");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const analytics_1 = require("@completeanatomy/analytics");
const constants_1 = require("../../constants");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
const ItemsList_1 = require("../ItemsList");
function ListTabContent({ type, accessLevel = bridge_schema_1.AccessLevel.Upgraded, onClick = noop_1.default, onResize = noop_1.default, className, withSelectedPart = false, }) {
    const { items = [] } = (0, hooks_1.useTabContent)(type) || {};
    const navigate = (0, react_router_dom_1.useNavigate)();
    const bridge = (0, bridge_1.useBridge)();
    const location = (0, react_router_dom_1.useLocation)();
    const analytics = (0, analytics_1.useAnalytics)();
    const handleClick = (0, react_1.useCallback)((index, e) => {
        onClick(e);
        const segmentation = {
            name: items[index].title,
            toolType: type,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
        const path = `/mode/${(0, constants_1.getTabKeyByType)(type)}`;
        navigate(path, { replace: path === location.pathname });
        if (!items) {
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type,
            index,
            identifier: items[index].identifier,
        });
    }, [onClick, type, analytics, navigate, location.pathname, items, bridge]);
    return ((0, jsx_runtime_1.jsx)(ItemsList_1.ItemsList, { className: className, onClick: handleClick, withSelectedPart: withSelectedPart, onResize: onResize, "data-e2e": 'ListTabContent_ItemsList', children: items === null || items === void 0 ? void 0 : items.map((item) => (Object.assign(Object.assign({}, item), { accessLevel: accessLevel }))) }));
}
exports.ListTabContent = ListTabContent;
